import { HiddenCheckbox, SwitchWrapper, Slider } from './styles';

type CustomSwitchProps = {
  checked: boolean;
  onChange: React.ChangeEventHandler<HTMLInputElement>;
  [key: string]: any;
};

export default function CustomSwitch({
  checked,
  onChange,
  ...rest
}: CustomSwitchProps): JSX.Element {
  return (
    <SwitchWrapper>
      <HiddenCheckbox checked={checked} onChange={onChange} {...rest} />
      <Slider checked={checked} />
    </SwitchWrapper>
  );
}
